import { useTranslation, Trans } from "react-i18next";

import main from '../../img/partner/girl.png'
import main2 from '../../img/partner/girl2.png'

import Fade from 'react-reveal/Fade'

function Main () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative bg-[#131313]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col xl:flex-row justify-between">
                <div className="flex flex-col items-start">
                    <Fade left><p className="text-[32px] xl:text-[68px] manrope text-white mt-[40px] xl:mt-[100px] font-[500] leading-[1.2] xl:max-w-[574px]">{t('partner.1')}</p></Fade>
                    <Fade left delay={200}><p className="manrope text-[12px] xl:text-[14px] xl:max-w-[455px] font-[300] text-[#FFFFFFB2] mt-[20px] xl:mt-[40px]">{t('partner.2')}</p></Fade>    
                </div>
                <Fade right delay={500}><img src={main} className="mt-[40px] xl:mt-0 hidden xl:block" alt="" /></Fade>
                <img src={main2} className="xl:hidden mt-[40px]" alt="" />
            </div>          
        </div>
    );
}

export default Main;